import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2202e0d1&scoped=true&"
import script from "./js/index.js?vue&type=script&lang=js&"
export * from "./js/index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=2202e0d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2202e0d1",
  null
  
)

export default component.exports